// ✅ index.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import authApi from '../../api/authApi';
import EditForm from './EditForm';
import SSHKeyForm from './SSHKeyForm';

function ProfilePage() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: '',
    email: '',
    desc: '',
    encrypted_private_key_name: '',
    private_key: ''
  });

  useEffect(() => {
    const token = localStorage.getItem('access');
    if (!token) {
      navigate('/login');
      return;
    }

    const fetchUser = async () => {
      try {
        const res = await authApi.get('/api/auth/me/');
        const { name, email, desc, encrypted_private_key_name } = res.data;
        setForm((prev) => ({ ...prev, name, email, desc, encrypted_private_key_name }));
      } catch (err) {
        console.error(err);
        navigate('/login');
      }
    };

    fetchUser();
  }, [navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleProfileSubmit = async (e) => {
    e.preventDefault();
    try {
      await authApi.put('/api/auth/me/', {
        name: form.name,
        email: form.email,
        desc: form.desc,
        encrypted_private_key_name: form.encrypted_private_key_name
      });
      alert('회원정보가 수정되었습니다.');
    } catch (err) {
      console.error(err);
      alert('수정 실패');
    }
  };

  const handleKeySubmit = async (e) => {
    e.preventDefault();
    if (!form.private_key) {
      alert('키 내용을 입력해주세요.');
      return;
    }

    try {
      await authApi.post('/api/auth/ssh-key/', {
        private_key: form.private_key,
        key_name: form.encrypted_private_key_name
      });
      alert('SSH 키가 등록되었습니다.');
      setForm((prev) => ({ ...prev, private_key: '' }));
    } catch (err) {
      console.error(err);
      alert('SSH 키 등록 실패');
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 py-16 px-4 flex justify-center items-start">
      <div className="w-full max-w-5xl bg-white shadow-lg rounded-xl p-8 space-y-12">
        <div>
          <h2 className="text-2xl font-bold text-center text-blue-700 mb-6">👤 회원정보 수정</h2>
          <EditForm form={form} onChange={handleChange} onSubmit={handleProfileSubmit} />
        </div>

        <hr className="border-gray-300" />

        <div>
          <h2 className="text-2xl font-bold text-center text-green-700 mb-6">🔐 SSH 키 등록</h2>
          <SSHKeyForm form={form} onChange={handleChange} onSubmit={handleKeySubmit} />
        </div>
      </div>
    </div>
  );
}

export default ProfilePage;